import { createSlice } from '@reduxjs/toolkit';
import { fetchCountriesEffect } from 'app/store/Countries/effects';
import { DDL } from 'types/general.types';

export interface CountriesState {
  countries?: DDL;
}

export const countriesInitialState: CountriesState = {};

const slice = createSlice({
  name: 'countries',
  initialState: countriesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCountriesEffect.fulfilled, (state, action) => {
      state.countries = action.payload.countryDDL.alpha2;
    });
  },
});

export const countriesReducer = slice.reducer;
